import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../core/services/auth.service';
import { AssistantBadgeService } from '../core/services/assistant-badge.service';
import { UserModel } from '../core/models/app.models';

interface NavItem {
  label: string;
  icon: string;
  routerLink?: string;
  comingSoon?: boolean;
  badge?: number;
}

@Component({
  selector: 'app-secured',
  templateUrl: './secured.component.html',
  styleUrl: './secured.component.scss'
})
export class SecuredComponent implements OnInit {
  mainItems: NavItem[] = [];
  agendaItems: NavItem[] = [];
  secondaryItems: NavItem[] = [];

  currentUser: UserModel | null = null;
  sidebarVisible: boolean = false;

  constructor(
    private authService: AuthService,
    private assistantBadgeService: AssistantBadgeService,
    private destroyRef: DestroyRef
  ) {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  ngOnInit(): void {
    this.mainItems = [
      { label: 'Dashboard', icon: 'pi pi-home', routerLink: '/secured/dashboard' },
      { label: 'Přestupy', icon: 'pi pi-arrow-right-arrow-left', routerLink: '/secured/transfers' },
      { label: 'Hráči', icon: 'pi pi-users', routerLink: '/secured/players' },
      { label: 'Kluby', icon: 'pi pi-shield', routerLink: '/secured/clubs' },
      { label: 'Asistentka', icon: 'pi pi-sparkles', routerLink: '/secured/assistant' },
    ];
    this.agendaItems = [
      { label: 'Komunikace', icon: 'pi pi-inbox', comingSoon: true },
      { label: 'Dokumenty', icon: 'pi pi-file', comingSoon: true },
    ];
    this.secondaryItems = [
      { label: 'Uživatelé', icon: 'pi pi-user-edit', routerLink: '/secured/users' },
      { label: 'Znalosti', icon: 'pi pi-book', routerLink: '/secured/knowledge' },
      { label: 'Přestupní řád', icon: 'pi pi-table', routerLink: '/secured/price-tables' },
    ];

    // Odznak "Asistentka" odebírá sdílený pendingCount$ (viz AssistantBadgeService) = otevřené
    // úkoly + čekající návrhy. TodoListComponent/ProposalsComponent po každé akci (odškrtnout/
    // nový úkol/schválit/upravit/zamítnout) zavolají assistantBadgeService.refresh() a odznak se
    // tím aktualizuje bez nutnosti restartu sidebaru.
    // pendingCount$ je root-singleton (přežívá SecuredComponent), takže odběr se musí ukončit
    // při zániku komponenty — jinak každý logout/login cyklus (SecuredComponent se vytváří znovu)
    // přidá další trvalý subscriber na app-lifetime BehaviorSubject.
    this.assistantBadgeService.pendingCount$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(count => {
      const assistantItem = this.mainItems.find(item => item.routerLink === '/secured/assistant');
      if (assistantItem) {
        assistantItem.badge = count;
      }
    });
    this.assistantBadgeService.refresh();
  }

  logout(): void {
    this.authService.logout();
  }

  get userInitials(): string {
    if (!this.currentUser) return '??';
    const first = this.currentUser.firstName?.charAt(0) ?? '';
    const last = this.currentUser.lastName?.charAt(0) ?? '';
    return (first + last).toUpperCase() || '??';
  }
}
